import {
  styled,
  Dialog as MuiDialog,
  Drawer as MuiDrawer,
  Typography,
  alpha,
} from '@mui/material';

export const Dialog = styled(MuiDialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(2px)',
    backgroundColor: alpha('#181818', 0.32),
  },
  '& .MuiDialog-paper': {
    padding: '30px',
    borderRadius: '16px',
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiDialog-container': {
      alignItems: 'flex-end',
    },
    '& .MuiDialog-paper': {
      padding: '27px 24px',
      maxWidth: theme.breakpoints.values.md,
      width: '100%',
      margin: '16px',
    },
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '24px',
  fontWeight: '600',
  color: theme.palette.text.primary,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
  },
}));
export const SubTitle = styled(Typography)(({ theme }) => ({
  fontWeight: '400',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '50%',
  },
}));

export const Drawer = styled(MuiDrawer)({});
